import React from "react";
import DataTable from "../../../components/DataTable";
const dataJson = [
  {
    id: "7df8sf5",
    sn: "01",
    sponsorId: "mono47854",
    userId: "mono75452",
    name: "John Doe",
    position: "Leader",
    dateOfJoining: "01/03/2022",
    status: "active",
  },
  {
    id: "df7sfs5f",
    sn: "02",
    sponsorId: "mono478",
    userId: "mono75784",
    name: "John Doe",
    position: "Leader",
    dateOfJoining: "01/03/2022",
    status: "active",
  },
  {
    id: "dfd8f8s",
    sn: "03",
    sponsorId: "mono47018",
    userId: "mono7504",
    name: "John Doe",
    position: "Leader",
    dateOfJoining: "01/03/2022",
    status: "active",
  },
];

const columns = [
  { id: "sn", label: "S.N", minWidth: 20 },
  { id: "sponsorId", label: "Sponsor ID", minWidth: 100 },
  {
    id: "userId",
    label: "User ID",
    minWidth: 80,
  },
  {
    id: "name",
    label: "Name",
    minWidth: 80,
  },
  {
    id: "position",
    label: "Position",
    minWidth: 100,
  },
  {
    id: "dateOfJoining",
    label: "Date Of Joining",
    minWidth: 80,
  },
  {
    id: "status",
    label: "Status",
    minWidth: 80,
  },
];

function createData(
  sn,
  sponsorId,
  userId,
  name,
  position,
  dateOfJoining,
  status,
) {
  return {
    sn,
    sponsorId,
    userId,
    name,
    position,
    dateOfJoining,
    status,
  };
}

const rows = dataJson.map((d) =>
  createData(
    d.sn,
    d.sponsorId,
    d.userId,
    d.name,
    d.position,
    d.dateOfJoining,
    d.status,
  )
);

const DownlineTable = () => {
  return (
    <DataTable
      columns={columns}
      rows={rows}
      perPageShow={6}
      tableHeight={440}
      className="common_table"
    />
  );
};

export default DownlineTable;
